var render = function render(){var _vm=this,_c=_vm._self._c;return _c('open-seadragon-viewer',{directives:[{name:"b-visible",rawName:"v-b-visible",value:(_vm.handleVisibilityChange),expression:"handleVisibilityChange"}],attrs:{"handler":_vm.handler}})
}
var staticRenderFns = []

export { render, staticRenderFns }